// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1qJu0","footer":"Form_footer__2Ke5P"};